import axios from "../../axios";

export default {
    getAllContracts(data) {
        return axios.get('activations/akg-contracts/all-contracts', {params: data})
    }
}